import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "../context/LanguageContext";
import Home1 from "../components/sections/Home_1";
import Home2 from "../components/sections/Home_2";
import Home3 from "../components/sections/Home_3";
import V2Home2 from "../components/sections/v2Home_2";

const Home = () => {
  const { translate } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{translate("meta.title_home")}</title>
        <meta name="description" content={translate("meta.description")} />
      </Helmet>
      <main>
        <Home1 />
        <V2Home2 />
        <Home2 />
        <Home3 />
      </main>
    </>
  );
};

export default Home;
